<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <div class="docs__top">
          <h1 class="docs__title">{{ t('docs.faq.title') }}</h1>
        </div>
        <div class="docs__main">
          <el-collapse v-model="collapse">
            <el-collapse-item
                v-for="(el, idx) of faq"
                :key="idx"
                :title="t(`docs.faq.content[${idx}].title`)"
                :name="idx + 1"
            >
              <i18n-t tag="p" scope="global" :keypath="`docs.faq.content[${idx}].text`">
                <template #email>
                  <a class="faq__link" :href="'mailto:team@digitalcardhouse.com'">team@digitalcardhouse.com</a>
                </template>
                <template #paymentMinimum>
                  <span>{{ paymentMin }}</span>
                </template>
                <template #paymentMaximum>
                  <span>{{ paymentMax }}</span>
                </template>
              </i18n-t>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import enGB from '@/locales/en-gb.json'
import {Processes} from "@/core/api/processes.js";

const {t} = useI18n();
const companyStore = useCompanyStore()

const companyInfo = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const paymentMin = ref('')
const paymentMax = ref('')

const faq = ref(enGB.docs.faq.content)
const collapse = ref([])

onMounted( async () => {
  const res = await Processes.getPaymentLimits()
  paymentMin.value = res.data.paymentsLimits.minAmount
  paymentMax.value = res.data.paymentsLimits.maxAmount
})
</script>

<style lang="scss" scoped>
.docs {
  padding-top: 150px;
  color: $white;

  &__top {
    border-bottom: 1px solid #1e1e1e;

    & h1 {
      width: fit-content;
      padding-bottom: 10px;
      border-bottom: 3px solid #3b3b3b;
      color: #3b3b3b;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  &__main {
    margin-top: 50px;
  }
}


:deep(.el-collapse) {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 100px;
  border: none;
}
:deep(.el-collapse-item) {
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
:deep(.el-collapse-item__header) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  background-color: $white;
  box-shadow: 0 0 30px 0 rgba(209, 209, 209, 0.25);
  padding: 15px 20px;
  height: unset;
  border: none;
  transition: 0.5s;

  color: #2F2F2F;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
}
:deep(.el-collapse-item__header.is-active) {
  border-radius: 10px 10px 0 0;
}
:deep(.el-collapse-item__wrap) {
  border-bottom: unset;
  padding-inline: 20px;
  border-radius: 0 0 10px 10px;
}
:deep(.el-collapse-item__content) {
  padding-bottom: 0;
  padding-block: 20px;

  color: #2F2F2F;
  text-align: justify;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
}

@media (max-width: 750px) {
  .docs {
    &__top {
      padding-block: 40px;
    }

    &__title {
      font-size: 42px;
    }
  }
}

@media (max-width: 550px) {
  :deep(.el-collapse-item__header) {
    font-size: 14px;
  }
  :deep(.el-collapse-item__content) {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>